import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router'
import { SelectBox, CustomLinkComponent } from 'msp-components'
import { useNavigation } from 'msp-integrations'

import { translations, navLinks } from './AccountMenu.constants'
import * as S from './AccountMenu.styles'

const AccountMenu = () => {
  const { formatMessage } = useIntl()
  const { pathname } = useLocation()
  const navigate = useNavigation()
  const [activeAccountNavItem, setActiveAccountNavItem] = useState(null)
  const [navLinksData, setNavLinksData] = useState([])

  useEffect(() => {
    const buildLinkData = (link) => {
      const classNames = [S.AccountMenuItem]
      const regex = new RegExp(`.*${link.path}$`)
      const isLinkActive = regex.test(pathname)
      const linkData = {
        ...link,
        id: link.path,
        value: formatMessage(translations[link.name])
      }

      if (isLinkActive) {
        classNames.push(S.AccountMenuItemActive)
        setActiveAccountNavItem(linkData)
      }

      linkData.className = classNames.join(' ')
      return linkData
    }

    const processednavLinksData = navLinks.map((navLink) => {
      const linkData = buildLinkData(navLink)
      return linkData
    })

    setNavLinksData(processednavLinksData)
  }, [pathname])

  const handleAccountNavigationChange = (
    _event: React.ChangeEvent<HTMLSelectElement>,
    selectedOption
  ) => {
    if (selectedOption) {
      navigate(selectedOption.path)
    }
  }

  return (
    <>
      {navLinksData.length > 0 && (
        <div className={S.AccountSelectMenuWrapper}>
          <SelectBox
            id={'account-select-navigation-menu'}
            value={activeAccountNavItem?.id}
            onChange={handleAccountNavigationChange}
            options={navLinksData}
          />
        </div>
      )}
      <div
        className={S.AccountMenuWrapper}
        data-testid='account-detail-nav'
        data-cy={'account-detail-nav'}
      >
        {navLinksData.map((navLinkItem) => {
          return (
            <CustomLinkComponent
              className={navLinkItem.className}
              inline={true}
              uppercase={false}
              href={navLinkItem.path}
              key={`account-menu-item-${navLinkItem.name}`}
            >
              {navLinkItem.value}
            </CustomLinkComponent>
          )
        })}
      </div>
    </>
  )
}

export default AccountMenu
